import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import { RootState } from '../../app/store'; // Replace with your app's root state type
import { closeCdaModal } from '../../features/modals/cda-modal-slice'; // Replace with the correct path to the modalSlice actions
import ModalBox from '../ModalBox';
import useGetAuthValues from '../../hooks/useGetAuthValues';

interface CdaModalProps {
  // Props for the modal component, e.g., onClose
}

const CdaModal: React.FC<CdaModalProps> = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state: RootState) => state.cdaModal.isOpen);
  const cdaViewerUrl = useSelector(
    (state: RootState) => state.cdaModal.cdaViewerUrl
  );
  const { user_email, access_token } = useGetAuthValues();

  const handleClose = useCallback(() => {
    dispatch(closeCdaModal());
  }, [dispatch]);

  if (!cdaViewerUrl) return null;

  const fullCdaViewerPath = new URL(cdaViewerUrl, window.location.origin);
  fullCdaViewerPath.searchParams.append('user_email', user_email);
  fullCdaViewerPath.searchParams.append('access_token', access_token);

  return (
    <>
      <Modal
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="actions-modal"
      >
        <ModalBox
          className="w-full h-full !max-w-screen-xl"
          closeButton={
            <Button
              className="!absolute right-2 top-2 !text-red-600"
              onClick={handleClose}
            >
              <CloseIcon />
            </Button>
          }
        >
          <iframe
            src={fullCdaViewerPath.pathname + fullCdaViewerPath.search}
            title="CDA Viewer"
            width="100%"
            height="100%"
            style={{ border: 'none' }}
          />
        </ModalBox>
      </Modal>
    </>
  );
};

export default CdaModal;
